import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { wellnessAPI } from "../services/api";

export function useWellnessHistorial(jugadorId: string) {
  return useQuery({
    queryKey: ["wellness", jugadorId],
    queryFn: () => wellnessAPI.historial(jugadorId).then(r => r.data),
    enabled: !!jugadorId,
  });
}
export function useDashboardGrupal(academiaId: string) {
  return useQuery({
    queryKey: ["wellness-dashboard", academiaId],
    queryFn: () => wellnessAPI.dashboardGrupal(academiaId).then(r => r.data),
    enabled: !!academiaId,
    refetchInterval: 60000, // refresca cada minuto
  });
}
export function useRegistrarWellness() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => wellnessAPI.registrar(data),
    onSuccess: (_, v) => qc.invalidateQueries({ queryKey: ["wellness", v.jugador_id] }),
  });
}
